import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CodeAssessmentStatisticsResponse, CmdbReadinessStatisticsResponse } from '../models/ai-statistics.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiStatisticsService {
  private readonly apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.apiUrl + '/admin/ai-statistics';
  }

  getCodeAssessmentStatistics(
    page: number,
    pageSize: number,
    dateFrom?: string,
    dateTo?: string
  ): Observable<CodeAssessmentStatisticsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    if (dateFrom) params = params.set('dateFrom', dateFrom);
    if (dateTo) params = params.set('dateTo', dateTo);
    return this.http.get<CodeAssessmentStatisticsResponse>(`${this.apiUrl}/code-assessment`, { params });
  }

  getCmdbReadinessStatistics(
    page: number,
    pageSize: number,
    dateFrom?: string,
    dateTo?: string
  ): Observable<CmdbReadinessStatisticsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    if (dateFrom) params = params.set('dateFrom', dateFrom);
    if (dateTo) params = params.set('dateTo', dateTo);
    return this.http.get<CmdbReadinessStatisticsResponse>(`${this.apiUrl}/cmdb-readiness`, { params });
  }
}
